import React, { useState, useRef, useEffect, useContext } from "react";

import { Box, Container, Grid, Typography, Stack, CircularProgress, FormControl, InputLabel, OutlinedInput, InputAdornment, TextField, Button, FormControlLabel, Switch, Chip, Select, MenuItem } from '@mui/material';

import CmsContext from '../../../../../store/cms-context';

import { getAccessJwtToken } from '../../../../../store/globalUtilities';

import TaskDialog from "./SubComponents/TaskDialog";

import AdapterDateFns from '@mui/lab/AdapterDateFns';

import cloneDeep from 'lodash/cloneDeep';

import FlowTasks from "./SubComponents/FlowTasks";

import { useTheme } from '@mui/material/styles';

import { grey , blue} from '@mui/material/colors';

import { default_shopify_mintsoft_inventory_sync_task_dialog } from "../../../../../Utilities/Metrics"

import { LoadingButton, LocalizationProvider, TimePicker } from "@mui/lab";

import SyncIcon from '@mui/icons-material/Sync';

import BarChart from "./SubComponents/BarChart"

import TimezoneSelect, { type ITimezone , allTimezones } from "react-timezone-select";

import { alpha, styled } from '@mui/material/styles';

import { has_product_management_write_access } from "../../../../../Utilities/HelperFunctions";


const marks = [
  {
    value: 0,
    label: '0x',
  },
  {
    value: 4,
    label: '4x',
  },
  {
    value: 5,
    label: '5x',
  },
  {
    value: 20,
    label: '20x',
  },
];

const product_states = ['ACTIVE', 'DRAFT', 'ARCHIVED'];

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};


function getStyles(name, personName, theme) {
  return {
    fontWeight: personName.includes(name)
      ? theme.typography.fontWeightMedium
      : theme.typography.fontWeightRegular,
  };
}


const CustomSwitch = styled(Switch)(({ theme }) => ({

  '& .MuiSwitch-switchBase': {
    '&.Mui-checked': {
      '& .MuiSwitch-thumb': {
        color:blue[800]
      }
    },
    '&:hover': {
      backgroundColor: alpha(blue[600], theme.palette.action.hoverOpacity),
    }
  },
  '& .MuiSwitch-thumb': {
    color:grey[200]
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: blue[300],
        opacity: 1,
        border: 0,
  },
  
}));


function ShopifyMintsoftInventorySync(props) {

  const theme = useTheme();

  const cmsContext = useContext(CmsContext);

  const isMountedRef = useRef(null);

  const [isLoading, setIsLoading] = useState(false);

  const [task_dialog_state, set_task_dialog_state] = React.useState(cloneDeep(default_shopify_mintsoft_inventory_sync_task_dialog));

  const [configurations, set_configurations] = React.useState({});

  useEffect(() => {

    isMountedRef.current = true

    get_inventory_sync_tasks()

    return () => isMountedRef.current = false;

  }, [])



  function show_link_accounts_dialog(action_type){

    if(Object.keys(configurations).length === 0){
      cmsContext.setSnackBarOpen(true, "error", "Invalid Configurations, please relaod page!")
      return
    }

    const temp_state = cloneDeep(default_shopify_mintsoft_inventory_sync_task_dialog)

    temp_state.all_stores = configurations.stores

    temp_state.mintsoft_clients = configurations.mintsoft_clients

    temp_state.mintsoft_warehouses = configurations.mintsoft_warehouses

    temp_state.shopify_inventory_locations = configurations.shopify_inventory_locations

    temp_state.is_dialog_open = true

    set_task_dialog_state(temp_state)

  }


  function handle_time_interval(index) {

    const temp_configurations = {...configurations}

    const temp_tasks = [...temp_configurations.tasks];

    console.log("interval task was: ", temp_tasks[index])

    // Check if time_interval is valid
    if (!temp_tasks[index].time_interval || isNaN(temp_tasks[index].time_interval.getTime())) {
      cmsContext.setSnackBarOpen(true, "error", "Please select a valid time interval!");
      return;
    }


    if(!temp_tasks[index].selected_intervals){
      temp_tasks[index].intervals_enabled =  true
      temp_tasks[index].selected_intervals = []
    }


    var found_duplicate = false;

    temp_tasks[index].selected_intervals.forEach((interval) => {

      if(interval.getHours() === temp_tasks[index].time_interval.getHours()){

        found_duplicate = true;

      }

    })

    if(found_duplicate){

      cmsContext.setSnackBarOpen(true, "error", "Time intervals should be distinct!")
      return

    }

    temp_tasks[index].selected_intervals.push(temp_tasks[index].time_interval)

    temp_tasks[index].selected_intervals.sort((a, b) => a - b);

    temp_configurations.tasks = temp_tasks

    set_configurations(temp_configurations)

  }

  function handle_time_interval_switch(index, checked) {

    const temp_configurations = {...configurations}

    console.log("interval config was: ", temp_configurations.tasks[index])

    temp_configurations.tasks[index].intervals_enabled = checked

    set_configurations(temp_configurations)

  }


  console.log('configurations were: ', configurations)


  return(

    <>

   {isLoading ? <CircularProgress style={{position: 'absolute', top: '50%', left: '50%', MozTransform: 'translateX(-50%) translateY(-50%)', WebkitTransform: 'translateX(-50%) translateY(-50%)', transform: 'translateX(-50%) translateY(-50%)'}} /> :
   
   <Box
    component="main"
    sx={{
      flexGrow: 1,
      py: 8,
    }}
  >


    <Container maxWidth={false} style={{maxWidth:"1000px",overflow:'visible'}}>
  
    <Grid
        container
        spacing={2}
        style={{overflow:'visible'}}
      >

        <Grid
          item
          xs={12}
        >

        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="flex-end"
          spacing={2}
        >

          <Typography variant="h5">Connections</Typography>

          <div>

          <LoadingButton loading={isLoading} variant="contained" onClick = {() => {show_link_accounts_dialog('Update')}}>Link Accounts</LoadingButton>

          </div>

        </Stack>

      </Grid>


      {Object.keys(configurations).length > 0 ? 
        
        <Grid
          item
          xs={12}
        >

          <Grid container spacing={3}>

            <Grid item xs={12}>

            <FlowTasks post_sync_task={post_sync_task} all_tasks={configurations.tasks}></FlowTasks>

            </Grid>

            {configurations.tasks.map((task, index) => { 

            return(

              <Grid key={index} item xs={12} >

              <Grid container spacing={2}>

              <Grid
              item 
              xs={12}
              >
              <div
              style={{display:'flex', width:'100%'}}
              >

              <Typography fontSize={14}><strong>{task.mintsoft_client.name} ({task.mintsoft_warehouse.name})</strong></Typography>

              <SyncIcon color="primary" sx={{marginLeft:1}}></SyncIcon>

              <Typography fontSize={14} sx={{marginLeft:1}}><strong>{task.shopify_store.name} ({task.shopify_inventory_location.name})</strong></Typography>

              </div>
    

              </Grid>

                <Grid
                item
                xs={6}
                >

                <FormControl size="small" fullWidth>
                <InputLabel id="demo-multiple-chip-label">Product States</InputLabel>
                <Select
                  labelId="demo-multiple-chip-label"
                  id="demo-multiple-chip"
                  multiple
                  size="small"
                  value={task.product_states}
                  onChange={(event) => {

                    const temp_configurations = {...configurations};
  
                    temp_configurations.tasks[index].product_states = event.target.value;
  
                    set_configurations(temp_configurations);
                    
                  }}
                  input={<OutlinedInput id="select-multiple-chip" label="Product States" />}
                  renderValue={(selected) => (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                      {selected.map((value) => (
                        <Chip key={value} label={value} sx={{ fontSize: '0.75rem', height: 24 }} />
                      ))}
                    </Box>
                  )}
                  MenuProps={MenuProps}
                >
                  {product_states.map((name) => (
                    <MenuItem
                      key={name}
                      value={name}
                      sx={{ fontSize: '0.82rem' }} // Adjust size here
                    >
                      {name}
                    </MenuItem>
                  ))}
                  </Select>
                </FormControl>

                </Grid>

                <Grid
                item
                xs={6}
                >

                    <div style={{position:'relative', zIndex:1000 - index, marginTop:1}}>

                    <TimezoneSelect
                    value={task.time_zone ? task.time_zone : ''} 
                    onChange={(value) => {

                      const temp_configurations = {...configurations};
                        
                      temp_configurations.tasks[index].time_zone = value;

                      set_configurations(temp_configurations);
                      
                    }}
                    >
                    
                  </TimezoneSelect>

                  </div>


                </Grid>
                

                <Grid
                  item
                  xs={6}
                >

                    <LocalizationProvider LocalizationProvider dateAdapter={AdapterDateFns}>
                    <TimePicker
                      label="Interval"
                      value={task.time_interval ? task.time_interval : null}
                      onChange={(newValue) => {

                        const temp_configurations = {...configurations};
  
                        temp_configurations.tasks[index].time_interval = newValue

                        set_configurations(temp_configurations);
                
                      }}
                      renderInput={(params) => <TextField size="small" {...params} fullWidth/>}
                    />
                  </LocalizationProvider>

                </Grid>

                <Grid
                  item
                  xs={6}
                >

                  <Button fullWidth variant="contained" onClick = {() => {handle_time_interval(index)}}>Add</Button>

                </Grid>


                {task.selected_intervals && task.selected_intervals.length > 0 ? 

                  <>

                <Grid
                item 
                xs={12}
                style={{padding:2, marginTop:2, marginLeft:1}}
                >
                  
                  <FormControlLabel
                  value="Sync Intervals"
                  control={<CustomSwitch checked={task.intervals_enabled ? task.intervals_enabled : false} onChange={(event) => {handle_time_interval_switch(index, event.target.checked)}} color="primary" />}
                  label={<Typography fontSize={13} color={grey[800]}><strong>Sync Intervals</strong></Typography>}
                  labelPlacement="start"
                  />

                </Grid>
                
                <Grid
                item
                xs={12}
                style={{padding:2, marginTop:1.5, marginLeft:14, marginRight:14}}
                >

                <Stack direction="row" spacing={1}>
                  {
                    task.selected_intervals.map((selected_interval, index2) => {
                      return(
                        <Chip key={index2} color="primary" variant="outlined" label={`${selected_interval.getHours().toString().padStart(2, '0')}:${selected_interval.getMinutes().toString().padStart(2, '0')}`} onDelete={() => {handle_interval_delete(index, index2)}} />
                      )
                    })
                  }
                </Stack>

                </Grid>

                </>

                : null}


                <Grid
                  item
                  xs={6}
                >

                  <Button fullWidth variant="contained" onClick = {() => {perform_immediate_sync(task)}}>Sync Now</Button>

                </Grid>

                
                <Grid
                  item
                  xs={6}
                >

                  <Button fullWidth variant="contained" onClick = {() => {update_sync_task(task)}}>Update</Button>

                </Grid>

              </Grid>
              
              </Grid>

              )
                
              })}

          </Grid>

        </Grid> : null}


      </Grid>

    </Container>


    <>

    {isLoading ? <CircularProgress style={{position: 'absolute', top: '50%', left: '50%', MozTransform: 'translateX(-50%) translateY(-50%)', WebkitTransform: 'translateX(-50%) translateY(-50%)', transform: 'translateX(-50%) translateY(-50%)'}} /> :
    
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          py: 8,
        }}
      >

      </Box>

      }

        </>       


    </Box>

     }

     {task_dialog_state ? <TaskDialog task_dialog_state={task_dialog_state} set_task_dialog_state={set_task_dialog_state} post_sync_task={post_sync_task}></TaskDialog> : null}


    </> 


  );


  function handle_interval_delete(index, index2) {

    const temp_configurations = {...configurations}

    console.log("interval account was: ", temp_configurations.tasks[index], " : ", index, " : ", index2)

    temp_configurations.tasks[index].selected_intervals.splice(index2, 1)

    if(temp_configurations.tasks[index].selected_intervals.length === 0){

      temp_configurations.tasks[index].intervals_enabled = false

    }

    console.log("updated task was: ", temp_configurations.tasks[index])

    set_configurations(temp_configurations)

  }



  function get_inventory_sync_tasks() {
    
    console.log('store_access_token')

    setIsLoading(true)

    getAccessJwtToken().then((auth_creds) => {

      fetch('https://fri7xzt2n6.execute-api.eu-west-2.amazonaws.com/SnagCMS/inventory/mintsoft/shopify', {
          crossDomain:true,
          method: 'GET',
          headers: {
            'Authorization':auth_creds.jwt
          }})
          .then(res => res.json())
          .then(
            (result) => {
              
              setIsLoading(false)
              
              console.log('result was',result)

              if(result.data){

                result.data.tasks.forEach((task) => {

                  if(task.selected_intervals){

                    const temp_intervals = [];

                    task.selected_intervals.forEach((interval) => {
                      // Reset today's date to midnight

                      const today = new Date();
                      
                      today.setHours(0, 0, 0, 0);
                      
                      // Split the time string into hours and minutes
                      const parts = interval.split(':');
                      const hours = parseInt(parts[0], 10);
                      const minutes = parseInt(parts[1], 10);

                      // Set the hours and minutes from the time string
                      today.setHours(hours);
                      today.setMinutes(minutes);

                      temp_intervals.push(today)

                    })

                    task.selected_intervals = temp_intervals

                  }

                });

                set_configurations(result.data)

              }else if(result.errorMessage){

                cmsContext.setSnackBarOpen(true, "error", result.errorMessage)
                
              } else{
                cmsContext.setSnackBarOpen(true, "error", "Error fetching data, please reload page")
                console.log('Error', result)
              }

            },
        
            (error) => {
              setIsLoading(false)
              cmsContext.setSnackBarOpen(true, "error", "Error fetching data, please reload page")
              console.log('error was',error)
            }
           
      )

    })

  }


  function set_dialog_loading(is_loading){

    const temp_contact_state = {...task_dialog_state}

    temp_contact_state.isLoading = is_loading

    set_task_dialog_state(temp_contact_state)

  }

  function reset_task_dialog_state(){

    set_task_dialog_state(cloneDeep(default_shopify_mintsoft_inventory_sync_task_dialog))

  }


  function post_sync_task(data) {
    
    const temp_state = {...task_dialog_state}

    console.log("state was: ", temp_state)

    var request_body = {}

    if(!data && (temp_state.action_type === "Create" || temp_state.action_type === "Update")) {

      request_body.request_type = temp_state.action_type

      if(!(temp_state.mintsoft_client.short_name && temp_state.mintsoft_warehouse.id && temp_state.shopify_store.store && temp_state.shopify_inventory_location.id)) {

        cmsContext.setSnackBarOpen(true, "error", "Please select valid values for all fields!")
        return

      } else {

        request_body.sync_task = {}
        request_body.sync_task.mintsoft_client = temp_state.mintsoft_client.short_name
        request_body.sync_task.mintsoft_warehouse = temp_state.mintsoft_warehouse.id
        request_body.sync_task.shopify_store = temp_state.shopify_store.store
        request_body.sync_task.shopify_inventory_location = temp_state.shopify_inventory_location.id

      }

    } else if(data) {

      console.log("data was: ", data)

      request_body.request_type = "Delete"

      request_body.sync_task = [configurations.tasks[data.task_index].id]

    } else {

      cmsContext.setSnackBarOpen(true, "error", "Invalid action type, please try again!")
      return

    }

    console.log('request body was: ', request_body)


    set_dialog_loading(true)


     getAccessJwtToken().then((auth_creds) => {
    
        if(!has_product_management_write_access(auth_creds.current_user)){
          cmsContext.setSnackBarOpen(true, "error", "You do not have permission to perform this action!")
          set_dialog_loading(false)
          return
        }
  
        fetch('https://fri7xzt2n6.execute-api.eu-west-2.amazonaws.com/SnagCMS/inventory/mintsoft/shopify', {
            crossDomain:true,
            method: 'POST',
            headers: {
              'content-type':'application/json',
              'Authorization':auth_creds.jwt
            },
            body: JSON.stringify(request_body)
          })
            .then(res => res.json())
            .then(
              (result) => {
      
                console.log('result was',result)
  
                set_dialog_loading(false)
  
                if(result.message){
  
                  cmsContext.setSnackBarOpen(true, "success", result.message)
  
                  reset_task_dialog_state()
  
                  get_inventory_sync_tasks()
                
                }else if(result.errorMessage){
  
                  cmsContext.setSnackBarOpen(true, "error", result.errorMessage)
                  
                }else{
  
                  cmsContext.setSnackBarOpen(true, "error", "Error completing request, please try again")
                  console.log('Error', result)
                }
    
              },
          
              (error) => {
                set_dialog_loading(false)
                cmsContext.setSnackBarOpen(true, "error", "Error completing request, please try again")
                console.log('error was',error)
              }
        )
  
      })

  }



    function perform_immediate_sync(task) {

      console.log("immediate sync task was:", task)

      const temp_task = cloneDeep(task)

      console.log('updating: ', temp_task)

      if(temp_task.product_states.length === 0) {

        cmsContext.setSnackBarOpen(true, "error", "Please select valid products states!")
        return

      }
      
      var request_body = {}
      
      request_body.task = {}

      request_body.task.mintsoft_client = temp_task.mintsoft_client.short_name

      request_body.task.mintsoft_warehouse = temp_task.mintsoft_warehouse.id

      request_body.task.shopify_store = temp_task.shopify_store.store

      request_body.task.shopify_inventory_location = temp_task.shopify_inventory_location.id

      request_body.task.product_states = temp_task.product_states

      console.log('request body was: ', request_body)

      setIsLoading(true)
  
      getAccessJwtToken().then((auth_creds) => {
  
        console.log("auth creds were: ", auth_creds)
        
        if(!has_product_management_write_access(auth_creds.current_user)) {

          cmsContext.setSnackBarOpen(true, "error", "You do not have permission to perform this action!")
          setIsLoading(false)
          return

        }
  
        fetch('https://fri7xzt2n6.execute-api.eu-west-2.amazonaws.com/SnagCMS/inventory/mintsoft/shopify/sync', {
            crossDomain:true,
            method: 'POST',
            headers: {
              'content-type':'application/json',
              'Authorization': auth_creds.jwt
            },
            body: JSON.stringify(request_body)
          })
            .then(res => res.json())
            .then(
              (result) => {
    
                setIsLoading(false)
    
                console.log('result was: ', result)
  
                if(result.message){
  
                  console.log('yes type rules')
  
                  cmsContext.setSnackBarOpen(true, "success", result.message)
  
                  get_inventory_sync_tasks()
                
                }else if(result.errorMessage){
  
                  cmsContext.setSnackBarOpen(true, "error", result.errorMessage)
                  
                }else{
  
                  cmsContext.setSnackBarOpen(true, "error", "Error fetching data, please reload page")
                  console.log('Error', result)
  
                }
    
              },
          
              (error) => {
                setIsLoading(false)
                cmsContext.setSnackBarOpen(true, "error", "Error completing request, please try again")
                console.log('error was',error)
              }
        )
              
  
      })

    }


    function update_sync_task(task) {

      const temp_task = cloneDeep(task)

      console.log('updating: ', temp_task)

      var request_body = {}

      if(temp_task.product_states.length === 0) {

        cmsContext.setSnackBarOpen(true, "error", "Please select valid products states!")
        return

      }

      if(temp_task.time_zone ==  null){
        cmsContext.setSnackBarOpen(true, "error", "Please select valid time zone!")
        return
      }

      const temp_intervals = []

      if(temp_task.selected_intervals){

        temp_task.selected_intervals.forEach((selected_interval) => {

          temp_intervals.push(`${selected_interval.getHours().toString().padStart(2, '0')}:${selected_interval.getMinutes().toString().padStart(2, '0')}`)

        })

      }

      console.log("temp intervals were: ", temp_intervals)

      temp_task.selected_intervals = temp_intervals

      if(!temp_task.intervals_enabled || temp_task.selected_intervals.length === 0){

        temp_task.intervals_enabled = false

      }

      temp_task.mintsoft_client = task.mintsoft_client.short_name

      temp_task.mintsoft_warehouse = task.mintsoft_warehouse.id

      temp_task.shopify_store = task.shopify_store.store

      temp_task.shopify_inventory_location = task.shopify_inventory_location.id

      request_body.sync_task = temp_task

      request_body.request_type = "Update"

      console.log('request body was: ', request_body)
  
      setIsLoading(true)
  
      getAccessJwtToken().then((auth_creds) => {
  
        console.log("auth creds were: ", auth_creds)
        
        if(!has_product_management_write_access(auth_creds.current_user)) {

          cmsContext.setSnackBarOpen(true, "error", "You do not have permission to perform this action!")
          setIsLoading(false)
          return

        }
  
        fetch('https://fri7xzt2n6.execute-api.eu-west-2.amazonaws.com/SnagCMS/inventory/mintsoft/shopify', {
            crossDomain:true,
            method: 'POST',
            headers: {
              'content-type':'application/json',
              'Authorization': auth_creds.jwt
            },
            body: JSON.stringify(request_body)
          })
            .then(res => res.json())
            .then(
              (result) => {
    
                setIsLoading(false)
    
                console.log('result was: ', result)
  
                if(result.message){
  
                  console.log('yes type rules')
  
                  cmsContext.setSnackBarOpen(true, "success", result.message)
  
                  get_inventory_sync_tasks()
                
                }else if(result.errorMessage){
  
                  cmsContext.setSnackBarOpen(true, "error", result.errorMessage)
                  
                }else{
  
                  cmsContext.setSnackBarOpen(true, "error", "Error fetching data, please reload page")
                  console.log('Error', result)
  
                }
    
              },
          
              (error) => {
                setIsLoading(false)
                cmsContext.setSnackBarOpen(true, "error", "Error completing request, please try again")
                console.log('error was',error)
              }
        )
              
  
      })

  
    }

  

};

export default ShopifyMintsoftInventorySync;